<div class="table-container mat-elevation-z2 mx-1 mt-4">
  <!-- Filtro y columnas -->
  <div class="row justify-between align-center" style="padding: 1em">
    <!-- Filtros -->
    <app-filtro-tabla
      class="flex-1"
      [datos]="[]"
      [search]="search"
      (onFilterChange)="cambioFiltro($event)"
    />
    <!-- Columnas -->
    <app-column-select
      [(columns)]="columnas"
      [columnNames]="nombreColumnas"
      [saveName]="saveColumnas"
    />
  </div>

  <!-- Paginator -->
  <mat-paginator
    [length]="totalCount"
    [pageSize]="helper.pageSize"
    [pageSizeOptions]="helper.pageSizeOptions"
    [showFirstLastButtons]="true"
    (page)="pageEvent($event)"
  />

  <!-- Tabla -->
  <mat-table
    class="responsive"
    [dataSource]="dataSource"
    matSort
    (matSortChange)="sortChange($event)"
  >
    <!-- Columna fecha  -->
    <ng-container matColumnDef="fecha">
      <mat-header-cell *matHeaderCellDef mat-sort-header>
        Fecha
      </mat-header-cell>
      <mat-cell *matCellDef="let row">
        <span class="mobile-label">Fecha:</span>
        {{ row.fecha | date: "short" }}
      </mat-cell>
    </ng-container>

    <!-- Columna FirmwareActual  -->
    <ng-container matColumnDef="firmwareActual">
      <mat-header-cell *matHeaderCellDef mat-sort-header>
        Firmware Actual
      </mat-header-cell>
      <mat-cell *matCellDef="let row">
        <span class="mobile-label">Firmware Actual:</span>
        {{ row.firmwareActual }}
      </mat-cell>
    </ng-container>

    <!-- Columna firmwareNuevo  -->
    <ng-container matColumnDef="firmwareNuevo">
      <mat-header-cell *matHeaderCellDef mat-sort-header>
        Firmware Nuevo
      </mat-header-cell>
      <mat-cell *matCellDef="let row">
        <span class="mobile-label">Firmware Nuevo:</span>
        {{ row.firmwareNuevo }}
      </mat-cell>
    </ng-container>

    <!-- Columna etapa  -->
    <ng-container matColumnDef="etapa">
      <mat-header-cell *matHeaderCellDef mat-sort-header>
        Etapa
      </mat-header-cell>
      <mat-cell *matCellDef="let row">
        <span class="mobile-label">Etapa:</span>
        {{ row.etapa }}
      </mat-cell>
    </ng-container>

    <!-- Columna Acciones -->
    <ng-container matColumnDef="acciones">
      <mat-header-cell *matHeaderCellDef> Acciones </mat-header-cell>>
      <mat-cell *matCellDef="let row">
        <span class="mobile-label">Acciones:</span>
        <button
          class="mx-1 no-shadow"
          mat-mini-fab
          color="warn"
          matTooltip="Eliminar"
          (click)="eliminar(row)"
        >
          <mat-icon>delete</mat-icon>
        </button>
      </mat-cell>
    </ng-container>

    <mat-header-row *matHeaderRowDef="columnas; sticky: true" />
    <mat-row *matRowDef="let row; columns: columnas" />
  </mat-table>

  <!-- Paginator -->
  <mat-paginator
    [length]="totalCount"
    [pageSize]="helper.pageSize"
    [pageSizeOptions]="helper.pageSizeOptions"
    [showFirstLastButtons]="true"
    (page)="pageEvent($event)"
  />
</div>
